import * as React from 'react';
export var LocationContext = React.createContext([{}, function () {}]);
export function useLocationContext() {
  var context = React.useContext(LocationContext);

  if (process.env.NODE_ENV === 'development' && context === undefined) {
    throw new Error('useQueryParams must be used within a QueryParamProvider');
  }

  return context;
}